import { useEffect, useState } from "react"
import api from "../../api"

const Modal = (props) => {

    const energia_id = props.energia_id


    const [consumoAnualIluminacaoTotal, setConsumoAnualIluminacaoTotal] = useState(0)
    const [cargaInstaladaTotal, setCargaInstaladaTotal] = useState(0)
    const [custoTotalAnualEnergiaEletrica, setCustoTotalAnualEnergiaEletrica] = useState(0)
    const [consumoAnualEnergiaTotal, setConsumoAnualEnergiaTotal] = useState(0)
    const [custoMedio, setCustoMedio] = useState(0)
    const [porcentagemConsumo, setPorcentagemConsumo] = useState(0)

    const [dadosIluminacaoResumo, setDadosIluminacaoResumo] = useState([])

    const carregaResumo = () => {

        //console.log(energia_id)
        api.get(`energiaIluminacaoResumo/${energia_id}`).then((result) => {

            //console.log(result.data)
                        
            const dadosGerais = result.data[0][0]

            //console.log(result.data[0][0])

            setConsumoAnualIluminacaoTotal(dadosGerais.consumoAnualIluminacaoTotal.toLocaleString('pt-BR'))
            setCargaInstaladaTotal(dadosGerais.cargaInstaladaTotal.toLocaleString('pt-BR', {minimumFractionDigits: 2}))
            setCustoTotalAnualEnergiaEletrica(dadosGerais.custoTotalAnualEnergiaEletrica.toLocaleString('pt-BR'))
            setConsumoAnualEnergiaTotal(dadosGerais.consumoAnualEnergiaTotal.toLocaleString('pt-BR'))
            setCustoMedio(dadosGerais.custoMedio.toLocaleString('pt-BR'))
            setPorcentagemConsumo(dadosGerais.porcentagemConsumo.toLocaleString('pt-BR'))

            //console.log(result.data[1])

            setDadosIluminacaoResumo(result.data[1].map((rs) => 
            
                <tr>

                    <td style={{ textAlign: 'right', width: '50%'}}>
                        
                        {rs.tipoTecnologia}&nbsp;
                    </td>
                    <td>
                    &nbsp;<b>{rs.total.toLocaleString('pt-BR')}</b> kWh
                    </td>

                </tr>
            
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }

    useEffect(() => {

        carregaResumo()

    }, [energia_id])


    return (

        <div>

            <div className="modal fade" id="modalEnergiaIluminacaoResumo" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Iluminacao - Resumo</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">

                                <div class="col-md-12">

                                    <table width="100%" border="1" className="table table-bordered table-striped table-hover">

                                        <tr>
                                            <td  style={{ backgroundColor: '#cef0ef'}}>
                                                Consumo Anual
                                            </td>

                                            <td>
                                            &nbsp;<b>{consumoAnualIluminacaoTotal}</b> kWh
                                            </td>
                                            <td>
                                            <b>{porcentagemConsumo}</b> % do Consumo Total Anual com Energia Elétrica
                                            </td>
                                        
                                            
                                        </tr>


                                        <tr style={{ display: 'none'}}>
                                            <td  style={{ backgroundColor: '#e6e8cf'}}>
                                                Custo Total Anual
                                            </td>

                                            <td>
                                            &nbsp;R$ <b>{custoTotalAnualEnergiaEletrica}</b>
                                            </td>
                                            <td>
                                                <b></b>% do Custo Total Anual com Energia Elétrica
                                            </td>
                                        
                                            
                                        </tr>


                                        <tr>
                                            <td  style={{ backgroundColor: '#cfcfe8'}}>
                                                Carga Instalada
                                            </td>

                                            <td>
                                            &nbsp;<b>{cargaInstaladaTotal}</b> kW
                                            </td>
                                            <td>
                                                &nbsp;
                                            </td>
                                        
                                            
                                        </tr>

                                        </table>




                                        <table width="100%" border="1" className="table table-bordered table-striped table-hover" style={{ display: 'none'}}>

                                        <tr>
                                            <td colspan="2" style={{ backgroundColor: '#e8d3cf'}}>
                                                <center>
                                                Eficiência Luminosa por Tipo
                                                </center>
                                            </td>

                                            
                                        </tr>

                                        {dadosIluminacaoResumo}

                                        </table>

                                    </div>

                            </div>
                                    

                            </div>
                            <div className="modal-footer">

                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}

export default Modal